import {
    call, put, select, takeLatest
} from 'redux-saga/effects';

import {
    PROCESS_UNSUBSCRIBE,
    unsubscribeSuccess,
    unsubscribeFailure
} from './unsubscribeModule';
import { getCapiClient } from '../session/sessionSelectors';
import { logAxiosError } from '../utils/errorUtils';

export const postUnsubscribe = (capiClient, token) => capiClient.post('/v4/unsubscribe/', { token });

export function* processUnsubscribeWorker({ payload: { token } }) {
    try {
        const capiClient = yield select(getCapiClient);
        yield call(postUnsubscribe, capiClient, token);
        yield put(unsubscribeSuccess());
    } catch (error) {
        logAxiosError(error);
        yield put(unsubscribeFailure());
    }
}

export function* unsubscribeSagasWatcher() {
    yield takeLatest(PROCESS_UNSUBSCRIBE, processUnsubscribeWorker);
}
